import { render, staticRenderFns } from "./MoralEducation.vue?vue&type=template&id=71bacf78&scoped=true&"
import script from "./MoralEducation.vue?vue&type=script&lang=js&"
export * from "./MoralEducation.vue?vue&type=script&lang=js&"
import style0 from "./MoralEducation.vue?vue&type=style&index=0&id=71bacf78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bacf78",
  null
  
)

export default component.exports